import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { TRANSITION } from '../../constants/shared/CommonConstants';
import TransitionWrapper from './TransitionWrapper';

const { APPEAR_AND_ENTER_TIME_OUT_TRANSITION, EXIT_TIME_OUT_TRANSITION } = TRANSITION;

const withAnimation = WrappedComponent => {
    const animated = props => {
        const { closeComponent, location, className, isGuidedTourOn } = props;

        const [transitionStart, setTransitionStart] = useState(false);

        useEffect(() => setTransitionStart(true), []);

        const onCloseWrappedComponent = () => setTransitionStart(false);

        return (
            <Transition
                in={transitionStart}
                timeout={{
                    appear: APPEAR_AND_ENTER_TIME_OUT_TRANSITION,
                    enter: APPEAR_AND_ENTER_TIME_OUT_TRANSITION,
                    exit: EXIT_TIME_OUT_TRANSITION,
                }}
                unmountOnExit
                onExited={() => closeComponent(location)}
            >
                {transitionState => (
                    <TransitionWrapper
                        className={className}
                        wrapperProps={props}
                        transitionState={transitionState}
                        onCloseWrappedComponent={onCloseWrappedComponent}
                        WrappedComponent={WrappedComponent}
                        isGuidedTourOn={isGuidedTourOn}
                    />
                )}
            </Transition>
        );
    };

    animated.defaultProps = {
        closeComponent: () => {},
        location: null,
        isGuidedTourOn: false,
    };

    animated.propTypes = {
        closeComponent: PropTypes.func,
        location: PropTypes.object,
        isGuidedTourOn: PropTypes.bool,
    };

    return animated;
};

withAnimation.defaultProps = {
    WrappedComponent: {},
};

withAnimation.propTypes = {
    WrappedComponent: PropTypes.object,
};

export default withAnimation;
